import request from '@/plugins/axios';
// /_product_/decInformation/create 创建申报
export function createdecInformationApi(data) {
    return request[7]({
        url: '/_product_/decInformation/create',
        method: 'post',
        data,
    })
}
//宣传申报列表
export function getPublicizeListApi(params) {
    return request[7]({
        url: '/_product_/decInformation/publicizeList',
        method: 'get',
        params,
    })
}
// /_product_/decInformation/update 修改申报
export function updateDecInformationApi(data) {
    return request[7]({
        url: '/_product_/decInformation/update',
        method: 'post',
        data,
    })
}
// /_product_/decInformation/myList 我的申报列表
export function decInformationMyListApi(params) {
    return request[7]({
        url: '/_product_/decInformation/myList',
        method: 'get',
        params,
    })
}
// /_product_/decInformation/info/{id} 根据唯一标识获取详情
export function decInformationinfoApi(id) {
    return request[7]({
        url: `/_product_/decInformation/info/${id}`,
        method: 'get',
    })
}
// /open/decUser/register 基层单位注册
export function decUserRegisterApi(params, data) {
    return request[7]({
        url: '/open/decUser/register',
        method: 'post',
        params, data,
    })
}
//  /_product_/decUser/updateProductUser 修改用户信息
export function updateProductUserApi(data) {
    return request[7]({
        url: '/_product_/decUser/updateProductUser',
        method: 'post',
        data,
    })
}
// /_product_/decInformation/delete/{id} 根据id删除信息
export function decInformationDeleteApi(id) {
    return request[7]({
        url: `/_product_/decInformation/delete/${id}`,
        method: 'delete',
    })
}
// /_product_/decInformation/download/{id} 下载文档
export function decInformationDownloadApi(id) {
    return request[7]({
        url: `/_product_/decInformation/download/${id}`,
        method: 'get',
    })
}

// /open/decUser/forgetPassword 产品用户忘记密码修改
export function decUserForgetPasswordApi(params, data) {
    return request[7]({
        url: '/open/decUser/forgetPassword',
        method: 'post',
        params, data,
    })
}

// /open/decUser/login 产品用户登录并获取令牌信息
export function decUserLoginApi(params) {
    return request[7]({
        url: '/open/decUser/login',
        method: 'get',
        params,
    })
}

// /open/decUser/list 产品用户登录时获取省属高校管理入口信息
export function decUserListApi(params) {
    return request[7]({
        url: '/open/decUser/list',
        method: 'get',
        params,
    })
}
// /open/oss/upload oss文件上传
export function openUploadApi(params) {
    return request[7]({
        url: '/open/oss/upload',
        method: 'post',
        data: params,
    })
}
//oss文件分片上传
export function openSplitUploadApi(params) {
    return request[7]({
        url: '/open/oss/uploadPart',
        method: 'post',
        data: params,
    })
}

// /open/decUser/sendSms 发送验证码
export function decUserSendSmsApi(data) {
    return request[7]({
        url: '/open/decUser/sendSms',
        method: 'post',
        data,
    })
}
// /_product_/decInformation/checkList 审核列表
export function decInformationCheckLisApi(params) {
    return request[7]({
        url: '/_product_/decInformation/checkList',
        method: 'get',
        params,
    })
}
//  /_product_/decUserAccess/checkList 专家审核列表
export function decUserAccessCheckLisApi(params) {
    return request[7]({
        url: '/_product_/decUserAccess/checkList',
        method: 'get',
        params,
    })
}
// /_product_/decInformation/back 退回申报
export function decInformationBackApi(params) {
    return request[7]({
        url: '/_product_/decInformation/back',
        method: 'post',
        params,
    })
}
// /_product_/decUser/info/{productUserId} 户详情信息
export function decUseriInfoApi(productUserId) {
    return request[7]({
        url: `/_product_/decUser/info/${productUserId}`,
        method: 'get',
    })
}
// /_product_/decUserAccess/update 专家推荐
export function decUserAccessUpdateApi(data) {
    return request[7]({
        url: '/_product_/decUserAccess/update',
        method: 'post',
        data,
    })
}

// /_internal_/decInformation/expertEvaluation 查看专家评分详情
// export function decInformationExpertEvaluationList(params) {
//     return request[7]({
//         url: `/_internal_/decInformation/expertEvaluation`,
//         method: 'get',
//         params
//     })

// }
//  /_product_/decUserAccess/info/{checkRecordId} 获取分配记录详情
export function decUserAccessInfoApi(checkRecordId) {
    return request[7]({
        url: `/_product_/decUserAccess/info/${checkRecordId}`,
        method: 'get',
    })
}











//POST
// /_product_/article/createArticle
// 发布图文文章
export function createArticle(data) {
    return request[0]({
        url: '/_product_/article/createArticle',
        method: 'post',
        data
    })
}

//POST
// /_product_/article/deleteArticle
// 删除图文文章
export function deleteArticle(params) {
    return request[0]({
        url: '/_product_/article/deleteArticle',
        method: 'post',
        params
    })
}

//GET
// /_product_/article/getInfo
// 查看图文文章详情
export function getArticleInfo(params) {
    return request[0]({
        url: '/_product_/article/getInfo',
        method: 'get',
        params
    })
}

//GET
// /_product_/article/list
// 图文文章列表
export function getArticleList(params) {
    return request[0]({
        url: '/_product_/article/list',
        method: 'get',
        params
    })
}

//POST
// /_product_/article/updateArticle
// 修改图文文章
export function updateArticle(data) {
    return request[0]({
        url: '/_product_/article/updateArticle',
        method: 'post',
        data
    })
}

//GET
// /_product_/loginSubscribe/getInfo
// 登录用户根据订阅管理员编号查看订阅号信息
export function getSubsInfo() {
    return request[0]({
        url: '/_product_/loginSubscribe/getInfo',
        method: 'get',
    })
}

export function transcoding(data) {
    return request[0]({
        url: '/fileOpen/transcoding',
        method: 'post',
        params: data
    })
}